// @flow
import type { City } from 'types/country';
import type { AppState } from 'reducers/app';
import type { StoreState } from 'reducers';

import _ from 'lodash';
import React, { Component } from 'react';
import { Grid } from 'semantic-grab-ui/src';
import Select from 'react-select';
import { connect } from 'react-redux';
import api from 'utils/api-utils';
import { LazyLoad } from 'components/custom/LazyLoad';

type Props = {
  onChange: Function,
  appState: AppState,
  cities: Array<City>,
};

export class GeofencePicker extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      options: [],
    };
    this.mapPolygons = [];
  }

  debouncedHandleSearchChange = () => _.debounce(this.handleSearchChange, 300);

  handleSearchChange = (value: String) => {
    this.setState({ isLoading: true });

    // get the city code from api
    api.get(this.props.appState, '/geofences', { limit: 1000, cityCode: this.state.currentCity.value, q: value })
      .then((response: Object) => {
        const options = response.data.map(d => ({ label: d.name, key: d.code, value: d }));
        this.setState({
          isLoading: false,
          options,
        });
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          options: [],
        });
      });
  }

  handleChange = (option: any) => {
    if (!(option && option.key)) return;

    api.get(this.props.appState, `/geofences/${option.key}`)
      .then((response: Object) => {
      // the geometry is guaranteed to be multipolygon for all the geofences
        const coordinates = _.get(response, 'data.geometry.coordinates');
        this.setState({ coordinates });
      });

    this.setState({ geofence: option });
    this.props.onChange(option.value);
  }


  handleCityChange = (option: any) => {
    this.setState({ currentCity: option }, () => {
      this.handleSearchChange();
    });
  }


  render () {
    const { cities } = this.props;
    const { options, geofence, isLoading, coordinates } = this.state;

    const cityOptions = cities.map(c => ({ label: c.name, key: c.code, value: c.code }));

    return (
      <div>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <label>City</label>
              <Select
                name="city-selector"
                options={cityOptions}
                onChange={this.handleCityChange}
                value={this.state.currentCity}
              />
            </Grid.Column>
            <Grid.Column>
              <label>Geofence</label>
              <Select
                name="geo-selector"
                value={geofence}
                options={options}
                onInputChange={this.debouncedHandleSearchChange()}
                onChange={this.handleChange}
                isLoading={isLoading}
                isDisabled={this.state.currentCity === undefined}
                isSearchable
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <div className="geo-rule-map">
          <LazyLoad
            asyncImport={() => import('./GrabMap.tsx')}
            childProps={{ coordinates }}
          />
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state: StoreState, ownProps: Object) {
  return {
    ...ownProps,
    appState: state.app,
  };
}

export default connect(mapStateToProps)(GeofencePicker);
